module.exports = function() {
  return new Worker(__webpack_public_path__ + "29290d5247d8df7d630e.worker.js");
};